import type { IconProps } from '../types/IconProps.ts';
export const SmileWink: IconProps = {
    name: 'SmileWink',
    children: [
        `<path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20" />`,
        `<path d="M7 15a6.14 6.14 0 0 0 10 0M8 10.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M14 10c.6-.94 1.69-1.68 3 0" />`,
    ]
};